import { Flex, Box, Text, Image } from "@chakra-ui/react";
import { useUserInfo } from "@/context/UserInfo";
import CloseEyeIcon from "./assets/closeEye.png";
import OpenEyeIcon from "./assets/openEye.png";
import { avatarImg } from "@/utils/avatars";
import { formatAmountWithFixed } from "@/utils/formatBalance";
import { usdcInfo } from "@/constants/tokens";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";
import { useNavigate } from "react-router-dom";
import { GoIcon } from "@/components/icons";
import KycStatus from "../myInfo/KycStatus";

const MyInfo = ({
  onOpen,
  showBalance,
  onChangeBalance,
}: {
  onOpen: () => void;
  showBalance: boolean;
  onChangeBalance: (showBalance: boolean) => void;
}) => {
  const { orgName, usdcBalance } = useUserInfo();
  const { avatarIndex } = useUserInfo();
  const { usdToCurrency, currencyUnit } = useCurrencyExchange();
  const navigate = useNavigate();
  return (
    <Flex align={"center"}>
      <Flex
        sx={{ cursor: "pointer" }}
        onClick={() => navigate("/myInfo")}
        align={"center"}
      >
        <Text
          sx={{
            fontSize: "30px",
            marginRight: "6px",
          }}
        >
          {avatarImg(avatarIndex)}
        </Text>
        <Box>
          <Flex
            sx={{
              marginBottom: "3px",
            }}
            align={"center"}
          >
            <Text sx={{ fontSize: "14px", fontWeight: "bold", color: "333" }}>
              {showBalance
                ? formatAmountWithFixed(
                    usdToCurrency(usdcBalance),
                    usdcInfo.decimals
                  )
                : "****"}{" "}
              {currencyUnit}
            </Text>
          </Flex>
          <Flex align={"center"}>
            {" "}
            <Text
              sx={{
                color: "#333",
                fontSize: "12px",
                fontWeight: 500,
                marginRight: "4px",
              }}
            >
              {orgName ? orgName : "Unnamed"}
            </Text>
            <KycStatus></KycStatus>
          </Flex>
        </Box>
      </Flex>

      <Image
        onClick={() => onChangeBalance(!showBalance)}
        src={showBalance ? OpenEyeIcon : CloseEyeIcon}
        sx={{
          width: "24px",
          marginLeft: "auto",
        }}
      ></Image>
    </Flex>
  );
};

export default MyInfo;
